import { axiosPrivate } from "../api/axios";
import { useEffect } from "react";
import useRefreshToken from "./useRefreshToken";
import { useAuth } from "./useAuth";

const useAxiosPrivate = () => {
  const refresh = useRefreshToken();
  // object to store ongoing requests cancel tokens
  const pendingRequests = new Map();

  useEffect(() => {
    const requestIntercept = axiosPrivate.interceptors.request.use(
      (config) => {

        // generate an identifier for each request
        const requestIdentifier = `${config.url}_${config.method}`;
        // check if there is already a pending request with the same identifier
        if (!pendingRequests.has(requestIdentifier)) {
        if (!config.headers["Authorization"]) {
          config.headers["Authorization"] = localStorage.getItem("tokenKey");
        }
        return config;
      }

        return {
          headers: {},
          method: config.method,
          url: ""
        };
      },
      (error) => Promise.reject(error)
    );

    const responseIntercept = axiosPrivate.interceptors.response.use(
      (response) => {
        // remove completed request from pending map
        const requestIdentifier = `${response.config.url}_${response.config.method}`;
        pendingRequests.delete(requestIdentifier);
        return response
      },
      async (error) => {
        const prevRequest = error?.config;

        if (error?.response?.status === 403 && !prevRequest?.sent) {
          prevRequest.sent = true;

          console.log("Attempting token refresh...");

          try {
            const newAccessToken = await refresh();
            if (newAccessToken) {
              prevRequest.headers["Authorization"] = newAccessToken;
              localStorage.setItem('tokenKey',newAccessToken)
              return axiosPrivate(prevRequest);
            }
          } catch (refreshError) {
            console.warn("Token refresh failed:", refreshError);
          }
        }
        // remove failed request from pending map
        if (error.config) {
          const requestIdentifier = `${error.config.url}_${error.config.method}`;
          pendingRequests.delete(requestIdentifier);
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axiosPrivate.interceptors.request.eject(requestIntercept);
      axiosPrivate.interceptors.response.eject(responseIntercept);
    };
  }, [refresh]);

  return axiosPrivate;
};

export default useAxiosPrivate;
